import React from 'react';

const LinkPreview = ({ preview }) => {
  if (!preview) return null;

  return (
    <a href={preview.url} target="_blank" rel="noopener noreferrer" className="block my-2">
      <div className="bg-gray-800 rounded-lg overflow-hidden border border-gray-700">
        {preview.image && <img src={preview.image} alt={preview.title} className="w-full h-32 object-cover" />}
        <div className="p-3">
          <p className="text-sm font-bold text-gray-200 truncate">{preview.title}</p>
          <p className="text-xs text-gray-400 truncate">{preview.description}</p>
          <p className="text-xs text-gray-500 mt-1 truncate">{preview.site}</p>
        </div>
      </div>
    </a>
  );
};

export default LinkPreview;
